export default "__VITE_ASSET__BH9go48f__"